import { ChevronLeftIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import Image from "../../Tags/Image";

export default function ProductsAndServices({ data = {} }) {
  const [productsWithoutDescription, setProductsWithoutDescription] = useState([]);
  const [productsWithDescription, setProductsWithDescription] = useState([]);
  const [showProductDetails, setShowProductDetails] = useState(false);
  const [currentProduct, setCurrentProduct] = useState({});
  const [shouldShowMoreDes, setShouldShowMoreDes] = useState(false);

  const handleViewDetails = (product) => {
    setCurrentProduct(product);
    if (product && product.customers && product.customers.length > 0) {
      setShowProductDetails(true);
      setShouldShowMoreDes(false);
    } else if (product && product.features && product.features.length > 0) {
      setShowProductDetails(true);
      setShouldShowMoreDes(false);
    } else if (product && product.pricing) {
      setShowProductDetails(true);
      setShouldShowMoreDes(false);
    } else {
      setShouldShowMoreDes(true);
    }
  };
  useEffect(() => {
    if (data.products && data.products.length > 0) {
      const arrWithout = data.products.filter(
        (item) => item.product_description === "" || !item.product_description
      );
      const arrWith = data.products.filter((item) => item.product_description);
      console.log("with without", { arrWithout, arrWith });
      setProductsWithoutDescription(arrWithout);
      setProductsWithDescription(arrWith);
    }

    return () => {
      setProductsWithoutDescription([]);
      setProductsWithDescription([]);
      setShowProductDetails(false);
      setCurrentProduct({});
    };
  }, [data?.products?.length]);

  useEffect(() => {
    console.log("currentProduct", currentProduct);
  }, [currentProduct]);

  return (
    <>
      {data && data.products && data.products.length > 0 && (
        <div className="border rounded-[14px] overflow-hidden border-border  bg-background relative mt-4 p-4 pb-2">
          {!showProductDetails && (
            <div className="mb-4">
              <span className="text-[16px] text-text-700 mr-3 font-bold">Products and Services</span>
              <span className="block text-sm">
                Explore the various products or services offered by the company. Click on a card to expand.
              </span>
            </div>
          )}
          {showProductDetails && currentProduct.name && (
            <>
              <div className="flex justify-between items-start mb-4">
                <span className="">
                  <span className="text-[16px] text-text-700 mr-3 font-bold inline-flex items-center">
                    {currentProduct?.name}
                    {currentProduct?.link && (
                      <a href={currentProduct?.link} target="_blank" className="ml-2">
                        {" "}
                        <Image className="no-invert" src="/images/ext/crm/hyperlink.svg" />
                      </a>
                    )}
                  </span>
                  {currentProduct?.product_description && (
                    <span className="text-sm block mt-1">{currentProduct?.product_description}</span>
                  )}
                </span>

                <div className="w-[200px] text-right">
                  <span
                    className="inline-flex items-center px-4 py-2 text-sm cursor-pointer border border-brand-700  bg-background rounded-lg"
                    onClick={() => {
                      setShowProductDetails(false);
                    }}
                  >
                    <ChevronLeftIcon width={16} height={16} /> Back
                  </span>
                </div>
              </div>

              {currentProduct.features && currentProduct.features.length > 0 && (
                <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4 mb-3">
                  {currentProduct.features.map((feature, index) => (
                    <div
                      key={index}
                      className="flex flex-col border rounded-[14px] overflow-hidden border-brand-200 bg-brand-50 p-4"
                    >
                      <div className="flex items-center">
                        <span className="text-[16px] text-gray-900 block">
                          {feature?.feature_name ? feature?.feature_name : "-"}
                        </span>
                      </div>
                      {feature.feature_description && (
                        <span className="text-sm mt-2 leading-relaxed">{feature.feature_description}</span>
                      )}
                      {feature.feature_subpoints && feature.feature_subpoints.length > 0 && (
                        <ul className="list-disc pl-5 mt-4 space-y-2 text-sm">
                          {feature.feature_subpoints.map((li, liIndex) => (
                            <li key={liIndex}>{li}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {currentProduct.customers && currentProduct.customers.length > 0 && (
                <div className="mt-4 mb-4">
                  <span className="text-[16px] text-text-700 mr-3 font-bold inline-flex items-center">
                    Featured Customers
                  </span>
                  <div className="mt-2">
                    {currentProduct.customers.map((customer) => (
                      <span className="inline-block text-[12px] bg-gray-50 text-gray-700 border border-gray-200 px-2 py-1 rounded-[20px] mr-3 mb-3">
                        {customer}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              {currentProduct.pricing && (
                <div className="mt-4 mb-4">
                  <span className="text-[16px] text-text-700 mr-3 font-bold inline-flex items-center">
                    Pricing
                  </span>
                  <div className="mt-2 text-sm">{currentProduct.pricing}</div>
                </div>
              )}
            </>
          )}
          {!showProductDetails && productsWithDescription && productsWithDescription.length > 0 && (
            <div className="mt-3 -mr-3">
              {productsWithDescription.map((product) => (
                <span className="inline-flex flex-col border rounded-[14px] overflow-hidden border-input  bg-gray-100 relative p-4 w-[48.5%] mr-[1.5%] mb-[1%] min-h-[145px]">
                  <span className="inline-flex items-center ">
                    <span className="text-[16px] text-gray-900 block">
                      {product?.name ? product?.name : "-"}
                    </span>

                    {product?.link && (
                      <a href={product?.link} target="_blank" className="ml-2">
                        {" "}
                        <Image className="no-invert" src="/images/ext/crm/hyperlink.svg" />
                      </a>
                    )}
                  </span>
                  {product.product_description && (
                    <span className="text-sm mt-2 leading-relaxed">
                      {shouldShowMoreDes && product?.name === currentProduct?.name ? (
                        product.product_description
                      ) : (
                        <>{`${product.product_description?.substring(0, 80)} ${
                          100 < product.product_description.length ? "... " : ""
                        }`}</>
                      )}
                    </span>
                  )}

                  {shouldShowMoreDes && product?.name === currentProduct?.name ? (
                    <span
                      className="text-sm mt-2 leading-relaxed cursor-pointer font-semibold text-gray-600"
                      onClick={() => {
                        setShouldShowMoreDes(false);
                      }}
                    >
                      Hide Details
                    </span>
                  ) : (
                    <span
                      className="text-sm mt-2 leading-relaxed cursor-pointer font-semibold text-gray-600"
                      onClick={() => {
                        handleViewDetails(product);
                      }}
                    >
                      View Details
                    </span>
                  )}
                </span>
              ))}
            </div>
          )}
          {!showProductDetails && productsWithoutDescription && productsWithoutDescription.length > 0 && (
            <div className="-mr-3">
              {productsWithoutDescription.map((product) => (
                <>
                  <span
                    target="_blank"
                    href={product?.link}
                    className="border rounded-[14px] overflow-hidden border-input  bg-gray-100 relative p-4 w-[48.5%] inline-flex items-center mr-[1.5%] mb-[1%]"
                  >
                    <span className="text-[16px] text-gray-900 block">
                      {product?.name ? product?.name : "-"}
                    </span>

                    {product?.link && (
                      <a href={product?.link} target="_blank" className="ml-2">
                        {" "}
                        <Image className="no-invert" src="/images/ext/crm/hyperlink.svg" />
                      </a>
                    )}
                  </span>
                </>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}
